<div class="toast-content">
  <mat-icon class="toast-icon">notifications</mat-icon>
  <div class="toast-body">
    <span class="toast-label">Nieuwe notificatie</span>
    <span class="toast-message">{{ data.message }}</span>
  </div>
  <div class="toast-actions">
    <button mat-stroked-button class="toast-read-btn" (click)="markAsRead()">Gelezen</button>
    <button mat-icon-button class="toast-close-btn" (click)="dismiss()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
